import api from '../services/api';
import { asyncAction } from './actions';

export const fetchAuditLogs = (studentId) => asyncAction(
  'FETCH_AUDIT_LOGS',
  api.auditLogs.list(studentId),
  { params: { studentId } },
);
